import React from "react";

export const ccOff = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.52222 11.9363C4.52222 14.3803 6.10822 16.0573 8.24022 16.0573C10.1252 16.0573 11.2822 14.9523 11.5812 13.3403H9.93022C9.65722 14.0813 9.16322 14.5753 8.24022 14.5753C6.96622 14.5753 6.21222 13.4443 6.21222 11.9363C6.21222 10.4153 6.96622 9.29731 8.24022 9.29731C9.16322 9.29731 9.65722 9.79131 9.93022 10.5193H11.5812C11.2822 8.92031 10.1252 7.81531 8.24022 7.81531C6.10822 7.81531 4.52222 9.49231 4.52222 11.9363ZM12.3044 11.9363C12.3044 14.3803 13.8904 16.0573 16.0224 16.0573C17.9074 16.0573 19.0644 14.9523 19.3634 13.3403H17.7124C17.4394 14.0813 16.9454 14.5753 16.0224 14.5753C14.7484 14.5753 13.9944 13.4443 13.9944 11.9363C13.9944 10.4153 14.7484 9.29731 16.0224 9.29731C16.9454 9.29731 17.4394 9.79131 17.7124 10.5193H19.3634C19.0644 8.92031 17.9074 7.81531 16.0224 7.81531C13.8904 7.81531 12.3044 9.49231 12.3044 11.9363Z"
      fill="white"
    />
    <rect
      x="0.75"
      y="3.80457"
      width="22.5"
      height="15.9545"
      rx="2.74091"
      stroke="white"
      stroke-width="1.5"
    />
  </svg>
);

export const ccOn = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.49091 3.05457C1.56293 3.05457 0 4.6175 0 6.54548V17.0182C0 18.9462 1.56293 20.5091 3.49091 20.5091H20.5091C22.4371 20.5091 24 18.9462 24 17.0182V6.54548C24 4.6175 22.4371 3.05457 20.5091 3.05457H3.49091ZM8.24002 16.0571C6.10802 16.0571 4.52202 14.3801 4.52202 11.9361C4.52202 9.49212 6.10802 7.81512 8.24002 7.81512C10.125 7.81512 11.282 8.92012 11.581 10.5191H9.93002C9.65702 9.79112 9.16302 9.29712 8.24002 9.29712C6.96602 9.29712 6.21202 10.4151 6.21202 11.9361C6.21202 13.4441 6.96602 14.5751 8.24002 14.5751C9.16302 14.5751 9.65702 14.0811 9.93002 13.3401H11.581C11.282 14.9521 10.125 16.0571 8.24002 16.0571ZM16.0222 16.0571C13.8902 16.0571 12.3042 14.3801 12.3042 11.9361C12.3042 9.49212 13.8902 7.81512 16.0222 7.81512C17.9072 7.81512 19.0642 8.92012 19.3632 10.5191H17.7122C17.4392 9.79112 16.9452 9.29712 16.0222 9.29712C14.7482 9.29712 13.9942 10.4151 13.9942 11.9361C13.9942 13.4441 14.7482 14.5751 16.0222 14.5751C16.9452 14.5751 17.4392 14.0811 17.7122 13.3401H19.3632C19.0642 14.9521 17.9072 16.0571 16.0222 16.0571Z"
      fill="white"
    />
  </svg>
);
